import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'btx-event-image',
  templateUrl: './event-image.component.html',
  styleUrls: ['./event-image.component.scss'],
  standalone: false
})
export class EventImageComponent implements OnInit {

  @Input() displayTicketCount: boolean = true;

  @Input() imageSrc: string | any;

  @Input() count: number=0;

  @Input("routerLink") routerLink: any[] | string = [];

  eventSmallImageSrc!: string;
  eventMidImageSrc!: string;
  eventNoSrc!: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
